export class TR {

	public td: string[];

	constructor() { 
		 		this.td = [];
 
	}
}
